module.exports = __webpack_public_path__ + "media/images/forgot-background-ab08b08920c1aee9b041ccd47afc6fd4.jpg";